import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

const styles: StyleRulesCallback = ({ breakpoints, palette, spacing: { unit }, typography }) => ({
  mainContainer: {
    background: palette.common.white,
    padding: `${unit * 4}px 0`,
    [breakpoints.up("sm")]: {
      padding: `${unit * 4}px ${unit * 3}px ${unit * 8}px`
    }
  },
  sectionContainer: {
    background: palette.common.white,
    margin: "0 auto",
    maxWidth: "1222px"
  },
  title: {
    fontWeight: typography.fontWeightMedium,
    marginBottom: unit * 3
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    margin: 0,
    padding: `${unit * 3}px ${unit * 5}px 0`,
    [breakpoints.up("sm")]: {
      padding: `${unit * 3}px 0 0`
    }
  },
  containerItem: {
    flexBasis: "50%",
    listStyleType: "none",
    padding: unit,
    [breakpoints.up("sm")]: {
      flexBasis: "33.33%",
      padding: `${unit}px 0`
    },
    [breakpoints.up("md")]: {
      flexBasis: "25%"
    }
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
